import { useState } from 'react';
import { Link } from 'react-router-dom';
import { contactService } from '../services/contactService';
import Recaptcha from '../components/common/Recaptcha';
import PublicNav from '../components/layout/PublicNav';
import PublicFooter from '../components/layout/PublicFooter';
import logo from '../assets/logo.png';

export default function ContactUs() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [captchaToken, setCaptchaToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await contactService.submit({ ...form, recaptcha_token: captchaToken });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not send your message. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <PublicNav />
      <div className="auth-bg" style={{ flex: 1, minHeight: 0 }}>
      <div style={{ width: '100%', maxWidth: '480px' }}>

        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.625rem', marginBottom: '0.75rem' }}>
            <img src={logo} alt="PCredit" style={{ height: 40, width: 'auto' }} />
          </div>
          <p style={{ color: 'var(--text-2)', fontSize: '0.9rem' }}>Get in touch with our team</p>
        </div>

        <div className="auth-card">
          {sent ? (
            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
              <div style={{
                width: 72, height: 72, borderRadius: '50%',
                background: 'rgba(0,200,150,0.12)', border: '1px solid rgba(0,200,150,0.3)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 1.25rem', fontSize: '2rem',
              }}>✓</div>
              <h2 style={{ fontSize: '1.375rem', fontWeight: 700, color: 'var(--text-1)', marginBottom: '0.5rem' }}>
                Message sent!
              </h2>
              <p style={{ color: 'var(--text-2)', marginBottom: '2rem', fontSize: '0.9rem' }}>
                Thanks for reaching out — we'll get back to you shortly.
              </p>
              <Link to="/" className="btn btn-primary btn-lg" style={{ width: '100%' }}>
                Back to home
              </Link>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: '1.75rem' }}>
                <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--text-1)', marginBottom: '0.4rem' }}>
                  Contact Us
                </h2>
                <p style={{ color: 'var(--text-2)', fontSize: '0.9rem' }}>
                  Questions, feedback, or need help? Send us a message.
                </p>
              </div>

              {error && <div className="alert alert-error"><span>⚠</span><span>{error}</span></div>}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Your name</label>
                  <input className="form-input" name="name" value={form.name} onChange={handleChange} required placeholder="John Doe" />
                </div>
                <div className="form-group">
                  <label className="form-label">Email address</label>
                  <input className="form-input" type="email" name="email" value={form.email} onChange={handleChange} required placeholder="you@example.com" />
                </div>
                <div className="form-group">
                  <label className="form-label">Subject</label>
                  <input className="form-input" name="subject" value={form.subject} onChange={handleChange} required placeholder="How can we help?" />
                </div>
                <div className="form-group">
                  <label className="form-label">Message</label>
                  <textarea className="form-input" name="message" value={form.message} onChange={handleChange} required rows={5} placeholder="Tell us more…" />
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', margin: '1.25rem 0' }}>
                  <Recaptcha onChange={setCaptchaToken} />
                </div>

                <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading || !captchaToken}>
                  {loading ? (
                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
                      <span style={{ width: 16, height: 16, borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', animation: 'spin .6s linear infinite', display: 'inline-block' }} />
                      Sending…
                    </span>
                  ) : 'Send message'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
      </div>
      <PublicFooter />
    </div>
  );
}
